import { render, staticRenderFns } from "./CadastrarRegiao.vue?vue&type=template&id=0500125a&scoped=true&lang=pug"
import script from "./CadastrarRegiao.vue?vue&type=script&lang=js"
export * from "./CadastrarRegiao.vue?vue&type=script&lang=js"
import style0 from "./CadastrarRegiao.vue?vue&type=style&index=0&id=0500125a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500125a",
  null
  
)

export default component.exports